/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q2Inputs */

const en_fw_faq_q2 = /** @type {(inputs: Fw_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many episodes does Firefly Wedding have?`)
};

const zh_fw_faq_q2 = /** @type {(inputs: Fw_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画一共几集？`)
};

/**
* | output |
* | --- |
* | "How many episodes does Firefly Wedding have?" |
*
* @param {Fw_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q2 = /** @type {((inputs?: Fw_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q2(inputs)
	return zh_fw_faq_q2(inputs)
});
export { fw_faq_q2 as "fw.faq.q2" }